window.$ = window.jQuery;

Drupal.behaviors.checkWidth = {
  attach: function (context) {
    const $button = $('.list-view .sidebar__expandable-toggle', context);

    function checkWidth() {
      var windowSize = window.innerWidth;
      if (windowSize <= 1100) {

        const $parent = $button.parent();
        let $region = $('.sidebar__expandable-inside', $parent),
          isExpanded = $button.attr('aria-expanded');
        $button.attr('aria-expanded', 'true');
      
        if (isExpanded === 'false') {
          $button.attr('aria-expanded', 'true');
          $region.addClass('show');
        } 

        else {
          $button.attr('aria-expanded', 'false');
          $region.removeClass('show');
        }
      }
    }
    
    const debounce = (callback, delay = 100) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    };
    
    checkWidth();
    
    const debounceCheck = debounce(checkWidth, 100);
    
    var cachedWidth = window.innerWidth;
    $(window).resize(function(){
      var newWidth = window.innerWidth;
      if(newWidth !== cachedWidth){
        debounceCheck();
        cachedWidth = newWidth;
      }
    });
  }
};

